<template>
  <!-- 上传组件 -->
  <div class="upload">
    <el-upload
      drag
      action="http://192.168.2.217:8001/api/admin/inouttype/list"
      :before-upload = "beforeUpload"
			:show-file-list="false" 
    > 
			<div v-if="loading" class="loading">
				<div class="el-loading-mask" style="">
					<div class="el-loading-spinner">
						<svg viewBox="25 25 50 50" class="circular">
							<circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
						</svg>
						<p class="el-loading-text">拼命导入中</p>
					</div>
				</div>
			</div>
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
			<div class="el-upload__tip" slot="tip">注：只能导入.xlsx/.xls文件</div> 
			<!-- <div v-if="uploadStatus==2" class="successStatus"> 
				<img src="../../../public/images/outAndIn/excel.png" alt="">
				<div class="success-name">{{fileName}}（{{fileSize}}KB）</div>
				<div class="success-text">上传成功！</div>
			</div> -->
    </el-upload>
  </div>
</template>
<script>
const XLSX = require("xlsx");
export default {
  props: {
    actionUrl: { default: "/" },
  },
  data() {
    return {
			uploadStatus : 1,//1:上传前 2：上传成功
			fileName: "",
			fileSize: "",
			loading: false,
		};
  },
  computed: {},
  watch: {
	},
  methods: {
    readFile(file) {
      return new Promise((resolve) => {
        let reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = (ev) => {
          resolve(ev.target.result);
        };
      });
    },
    async readExcelFile(file, sheetIndex) {
      let data = await this.readFile(file);
      let workbook = XLSX.read(data, { type: "binary" });
      let worksheet = workbook.Sheets[workbook.SheetNames[sheetIndex]];
      data = XLSX.utils.sheet_to_json(worksheet);
      return data;
    },
    beforeUpload(file) {
			this.loading = true;
			const isXlsxOrXls =
				file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
				file.type === 'application/vnd.ms-excel';
			this.fileName = file.name;
			this.fileSize = Math.ceil(file.size / 1024);
			if (!isXlsxOrXls) {
				this.loading = false;
				this.$message.error('您只能上传excel文件!');
				// this.uploadStatus = 1;   
				this.disabled = false;      
				// return false
			} else {
				let data = this.readExcelFile(file, 0);
				data.then((json) => {
					this.loading = false;
					this.$emit('getFileJson', {
						json: json,
						fileName: this.fileName,
						fileSize: this.fileSize
					})
					this.disabled = true; 
					// this.uploadStatus = 2;  
				})
				.catch(err=>{
					this.loading = false;
					// this.uploadStatus = 1; 
					this.disabled = false;   
					this.$message.error('文件格式错误或文件内容个数错误!');
					// return false
				})
			}
			return false
		}
  },
  components: {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
	position: relative;
	.loading {
		position: absolute;
		top: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background: rgba(0, 0, 0, 0.1);
    z-index: 9999;
    box-sizing: border-box;
	}
	.successStatus {
		img {
			margin-bottom: 10px;
    	margin-top: 20px;
		}
		.success-text {
			font-size: 14px;
			color:#666;
			margin-top: 5px;
		}
		.success-name {
			font-size: 16px;
			color:#333;
		}
	}
}
</style>
